import cn from 'classnames'
import { CustomForm } from 'components/Forms/CustomForm'
import { useEffect, useState } from 'react'
import { setLoading } from '../../redux/store/common/slice'
import { useDispatch, useSelector } from 'react-redux'
import { Input } from '../Input'
import { LABELS, PLACEHOLDERS } from '../../constants'
import './forms.addBankAccount.scss'
import { TOption } from '../Select/types'
import { notification } from '../Notification'
import {
  TCommunityDetailsForm,
  TCommunityDetailsError,
  TCommunityDetailsProps
} from './forms.communityDetails.d'
import { Select } from '../Select'
import { getGpoList } from '../../features/MyCommunity/Gpo/api'
import { initialState } from '../../pages/AddGpo/constants'
import { RowLayout } from '../../features/MyCommunity/Vendors/VendorCreation/General/VendorForm/RowLayout'
import { validateMessages } from '../../helper/common'
import './forms.communityDetails.scss'
import { updateCommunityInfo } from '../../features/MyCommunity/api'
import { getUser } from '../../redux/store/user/getters'
import { AxiosResponse } from 'axios'

export const CommunityDetails = ({
  form,
  setIsActive
}: TCommunityDetailsProps) => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const [gpoList, setGpoList] = useState<TOption[]>([])
  const [errors, setErrors] = useState<TCommunityDetailsError>({})

  const fetchGpoList = async () => {
    await getGpoList({}).then((res) => {
      setGpoList(
        res.data.results.map((option) => ({
          label: option.name,
          value: option.uuid
        }))
      )
    })
  }

  const getSelectorsData = async () => {
    dispatch(setLoading(true))
    try {
      fetchGpoList()
    } finally {
      dispatch(setLoading(false))
    }
  }

  useEffect(() => {
    getSelectorsData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFinish = async (formData: TCommunityDetailsForm) => {
    if (!user.community) return
    setIsActive(false)

    dispatch(setLoading(true))
    try {
      await updateCommunityInfo(
        {
          gpo: { uuid: formData.gpo_relation || null },
          name: formData.name,
          description: formData.description,
          legal_name: formData.legal_name
        },
        user.community
      )
    } catch (error) {
      const e = error as AxiosResponse
      setIsActive(true)
      if (e.data.details) {
        notification.error({ message: e?.data.details })
      }
      setErrors(e.data)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <CustomForm<TCommunityDetailsForm>
      form={form}
      onFinish={handleFinish}
      initialValues={initialState}
      validateMessages={validateMessages}
      onFieldsChange={() => {
        setErrors({})
        setIsActive(true)
      }}
      id="community-details-form"
      className={cn('community-details-form')}
    >
      <div className="community-details">
        <RowLayout title="Business information">
          <>
            <Input
              propsItem={{
                name: 'name',
                label: LABELS.COMMUNITY_NAME_DOING_BUSINESS_AS,
                help: errors?.name?.[0],
                validateStatus: errors.name && 'error',
                rules: [
                  {
                    max: 64,
                    required: true
                  }
                ]
              }}
              propsInput={{
                showCount: true,
                maxLength: 64
              }}
            />
            <Input
              propsItem={{
                name: 'legal_name',
                label: LABELS.COMMUNITY_LEGAL_NAME,
                help: errors?.legal_name?.[0],
                validateStatus: errors.legal_name && 'error'
              }}
              propsInput={{
                showCount: true,
                maxLength: 64
              }}
            />
            <Input.TextArea
              propsItem={{
                name: 'description',
                label: LABELS.DESCRIPTION,
                help: errors?.description?.[0],
                validateStatus: errors.description && 'error',
                rules: [
                  {
                    max: 250
                  }
                ]
              }}
              propsTextArea={{
                showCount: true,
                maxLength: 250
              }}
            />
          </>
        </RowLayout>
        <div className="form__divider mb-24" />
        <RowLayout
          title="Group purchasing organization"
          subtitle={
            'GPO selection is not required. Leave blank if none applies.'
          }
        >
          <Select
            options={gpoList}
            className="long-select"
            propsItem={{
              label: LABELS.GPO_NAME,
              name: 'gpo_relation',
              help: errors?.gpo_relation?.[0],
              validateStatus: errors?.gpo_relation && 'error'
            }}
            propsSelect={{
              required: true,
              placeholder: PLACEHOLDERS.TYPE_IN_GPO_NAME,
              allowClear: true
            }}
          />
        </RowLayout>
      </div>
    </CustomForm>
  )
}
